import { Container } from "react-bootstrap";
import { Component } from "react";
import Faq from "react-faq-component";
import "./faq.css";

export default class ContentFAQ extends Component {
  render() {
    const data = {
      title: "سوالات متداول",
      rows: [
        {
          title: "علت برگشت مرسولات پستی چیست؟",
          content: `
                    مرسولات پستی به دلایلی مانند نقص نشانی گیرنده، عدم مراجعه گیرنده برای دریافت مرسوله ثبتی، نقل مکان گیرنده محترم، شناخته نشدن گیرنده در نشانی مندرج روی مرسوله، فوت گیرنده و غیره احتمال دارد که توزیع نشده و به فرستنده مرسوله بازگشت داده شود.`,
        },
        {
          title: "داخل یک نامه چه چیزهایی می توان قرار داد؟ ",
          content: `
                        بر اساس قوانین پستی مرسولات نامه باید صرفا حاوی اسناد، مدارک و مکاتبات باشد و قرار دادن هر نوع شی و کالا در ارسال مرسوله پستی به عنوان کالای ممنوعه پستی شناخته می‌شود
                        `,
        },
        {
          title: "هزینه‌های پستی دریافتی از مشتری چیست؟",
          content: `
                    غیر از هزینه ارسال کالا ریز هزینه‌های پستی دریافت شده از مشتریان شامل کرایه پستی، هزینه لفاف بندی و بسته بندی مرسوله و غیره در قبض رسید فرستنده درج می‌شود.`,
        },
        {
          title: "مهلت نگهداری مرسولات پستی چقدر است؟",
          content: `
                    ارسال مرسوله پستی با توجه به نوع سرویس، مدت زمان مشخصی (به عنوان مثال مرسوله پیشتاز تا ۵ روز پس از دو بار مراجعه پستچی به نشانی گیرنده محترم در باجه نگهداری می شود ) جهت تحویل به گیرنده در محل اداره پست نگهداری می‌شود. در این زمینه مشتری می‌تواند به استناد نشانی مندرج بر روی اطلاعیه ورود به اداره پست مراجعه کرده و برای دریافت مرسوله خود اقدام کند.`,
        },
      ],
    };

    const styles = {
      // bgColor: 'white',
      titleTextColor: "#ff6600",
      rowTitleColor: "#4B1483",
      // rowContentColor: 'grey',
      arrowColor: "#ff6600",
    };

    const config = {
      animate: true,
      // arrowIcon: "V",
      tabFocus: true,
    };

    return (
      <>
        <Container style={{ direction: "rtl", marginTop: "3rem" }}>
          <div>
            <Faq data={data} styles={styles} config={config} />
          </div>
        </Container>
      </>
    );
  }
}
